import React, { useState } from "react";
import {
  Box,
  Button,
  Container,
  TextField,
  Typography,
  Alert,
  CircularProgress
} from "@mui/material";
import axios from "axios";
import { useNavigate } from "react-router-dom";

const REACT_APP_EXPRESS_SERVER = process.env.REACT_APP_EXPRESS_SERVER;

const ForgotPassword = () => {
  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [success, setSuccess] = useState(false);
  const navigate = useNavigate();

  const handleChange = (e) => {
    setEmail(e.target.value);
    setError(null);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError(null);
    
    try {
      // Call your backend API to send OTP
      const response = await axios.post(`${REACT_APP_EXPRESS_SERVER}/request-password-reset`, { 
        email: email 
      });

      if (response.data.success) {
        setSuccess(true);
        // Navigate to OTP verification page after 2 seconds
        setTimeout(() => {
          navigate("/verify-otp", { state: { email } });
        }, 2000);
      } else {
        setError(response.data.message || "Failed to send OTP");
      }
    } catch (err) {
      setError(
        err.response?.data?.error || 
        err.response?.data?.message || 
        "An error occurred while sending OTP"
      );
    } finally {
      setLoading(false);
    }
  };

  return (
    <Container maxWidth="sm">
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          mt: 8,
          p: 4,
          borderRadius: 2,
          boxShadow: 3,
          backgroundColor: "white",
          textAlign: "center",
        }}
      >
        <img 
          src="https://jms.co.ug/wp-content/uploads/2022/06/JMS_logo-1.png" 
          alt="Logo" 
          style={{ width: 100, marginBottom: 16 }} 
        />
        <Typography variant="h6" gutterBottom>
          Forgot Password
        </Typography>
        <Typography variant="body2" sx={{ color: "grey" }} gutterBottom>
          Enter your email address to reset your password
        </Typography>

        {error && (
          <Alert severity="error" sx={{ width: '100%', mb: 2 }}>
            {error}
          </Alert>
        )}

        {success && (
          <Alert severity="success" sx={{ width: '100%', mb: 2 }}>
            OTP sent successfully! Redirecting to verification page...
          </Alert>
        )}

        <Box component="form" onSubmit={handleSubmit} sx={{ width: "100%" }}>
          <TextField
            fullWidth
            required
            label="Email"
            type="email"
            name="email"
            value={email}
            onChange={handleChange}
            sx={{ mb: 2 }}
            disabled={loading || success}
          />
          <Button
            fullWidth
            variant="contained"
            sx={{ 
              backgroundColor: "#5C2626", 
              color: "white",
              "&:hover": { backgroundColor: "#4a1e1e" },
              height: "48px"
            }}
            type="submit"
            disabled={loading || success || !email}
          >
            {loading ? (
              <CircularProgress size={24} color="inherit" />
            ) : (
              "Send Reset OTP Code"
            )}
          </Button>
          <Typography variant="body2" sx={{ mt: 2 }}>
            Remember your password? <a href="/signin">Sign in</a>
          </Typography>
        </Box>
      </Box>
    </Container>
  );
};

export default ForgotPassword;